import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { defaultMapper } from './getSortOrder';

export function getSortOrderByPeriod<T>(col: ITableColumn<T>): string {
  if (col.id === 'period') {
    return `start_date,${col.sort};stop_date,${col.sort}`;
  }

  return defaultMapper<T>(col);
}
